import { red } from "@material-ui/core/colors";
import { createTheme } from "@material-ui/core/styles";
import blue from "@material-ui/core/colors/blue";
import pink from "@material-ui/core/colors/pink";

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: blue,
    secondary: pink,
    error: {
      main: red.A400,
    },
    background: {
      default: "#fff",
    },
  },
  typography: {
    fontFamily: "Hind", // specifying a new font
    h5: {
      fontWeight: "bold",
      fontSize: "1.5rem",
    },
  },
  overrides: {
    MUIDataTable: {
      responsiveScroll: {
        maxHeight: "980px",
      },
    },
  },
});

export default theme;
